import React, { useState } from 'react';
import { JUSTIFICATIVA_PADRAO_EXCLUSAO_LOTE } from '../utils/justificativasPadrao';

interface Props {
  quantidadeSelecionada: number;
  excluindo: boolean;
  onCancelar: () => void;
  onConfirmar: (justificativaComum: string) => void;
}

// Seção 12.5 — exclusão em lote com justificativa comum (que pode ser revisada individualmente
// depois, via "Editar Empresa Excluída" na lista de excluídas).
const ExclusaoEmLoteModal: React.FC<Props> = ({ quantidadeSelecionada, excluindo, onCancelar, onConfirmar }) => {
  const [justificativa, setJustificativa] = useState(JUSTIFICATIVA_PADRAO_EXCLUSAO_LOTE);
  const [tentouEnviar, setTentouEnviar] = useState(false);

  const confirmar = () => {
    setTentouEnviar(true);
    if (justificativa.trim().length === 0) return;
    onConfirmar(justificativa.trim());
  };

  return (
    <div className='circ-modal-backdrop' onMouseDown={(e) => e.target === e.currentTarget && onCancelar()}>
      <div className='circ-modal' style={{ maxWidth: 460 }}>
        <div className='circ-modal-header'>
          <h4>Excluir Empresas Selecionadas</h4>
          <button type='button' className='btn btn-sm btn-icon btn-light' aria-label='Fechar' onClick={onCancelar}>
            <i className='bi bi-x-lg' />
          </button>
        </div>
        <div className='circ-modal-body'>
          <p style={{ fontSize: 13 }}>
            <strong>{quantidadeSelecionada}</strong> empresa{quantidadeSelecionada === 1 ? '' : 's'} selecionada
            {quantidadeSelecionada === 1 ? '' : 's'} será{quantidadeSelecionada === 1 ? '' : 'ão'} excluída
            {quantidadeSelecionada === 1 ? '' : 's'} da circularização.
          </p>
          <div className='circ-form-group'>
            <label className='circ-campo-obrigatorio'>Justificativa comum da exclusão</label>
            <textarea
              className='circ-form-control'
              rows={3}
              value={justificativa}
              onChange={(e) => setJustificativa(e.target.value)}
              placeholder='Essa justificativa será aplicada a todas as empresas selecionadas — revise individualmente se necessário.'
            />
            {tentouEnviar && justificativa.trim().length === 0 && (
              <div className='text-danger mt-1' style={{ fontSize: 12 }}>A justificativa é obrigatória.</div>
            )}
          </div>
        </div>
        <div className='circ-modal-footer'>
          <button type='button' className='btn btn-sm btn-light' disabled={excluindo} onClick={onCancelar}>
            Cancelar
          </button>
          <button type='button' className='btn btn-sm btn-danger' disabled={excluindo} onClick={confirmar}>
            {excluindo && <span className='spinner-border spinner-border-sm me-1' />}
            Confirmar Exclusão em Lote
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExclusaoEmLoteModal;
